<template>
  <PanelRow class="oneline">
    <!--<Panel class="submenu">

    </Panel>-->
    <ul class="apps">
      <li
        is="Panel"
        tag="li"
        v-for="(app, appname) in apps"
        :key="appname"
        class="panel"
        :class="{open:open===appname, beforeopen: beforeopen===appname}"
      >
        <article v-if="open === appname">
          <h3>{{ 'apps.description' | trans }}</h3>
          <p>{{ app.description | trans }}</p>
          <!--<h3>{{ 'apps.setuptime' | trans }}</h3>
          <p>{{ app.setuptime }}</p>-->
        </article>
        <router-link v-else :to="app.url">
          <figure>
            <img :src="app.logo" alt="" />
          </figure>
        </router-link>
        <nav>
          <router-link :to="app.url" class="link">
            <h2>{{ app.name | trans }}</h2>
          </router-link>
          <button class="btn inverse info" @click="open = open !== appname && appname" v-if="app.description">
            {{ (open === appname ? 'buttons.back' : 'buttons.info') | trans }}
          </button>
        </nav>
      </li>
    </ul>
  </PanelRow>
</template>

<script>
  import apps_list from './apps_list'
  export default {
    name: 'Apps',
    data () {return {
      open: null,
      apps: apps_list,
    }},
    computed: {
      beforeopen () {
        var appnames = Object.keys(this.apps);
        var openkey = appnames.indexOf(this.open);
        if (openkey > 0) {
          return appnames[openkey-1];
        }
        return null;
      }
    },
  }
</script>

<style lang="scss" scoped>
  ul.apps {
    flex-grow: 2;

    //flex layout (oldish browsers)
    display: flex;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: flex-start;

    //grid layout
    display: inline-grid;
    grid-template-columns: 33% 33% 33%;
    @media (max-width: $md-max) {
      grid-template-columns: 50% 50%;
    }
    justify-items: stretch;
    align-items: stretch;
    @media (max-width: $xs-max) {
      display: block;
    }

    > li {

      //flex layout (oldish browsers)
      flex-basis: calc(33% - #{2*$panel-margin});
      order: 1;
      &.open {
        flex-basis: calc(66% - #{2*$panel-margin});
        display: flex;
        flex-direction: column;
        > :nth-last-child(2) {
          flex-grow: 1;
        }
      }
      &.beforeopen {
        &:nth-of-type(3n+2) {
          order: 2;
          + .open {
            order: 1;
          }
        }
      }
      flex-grow: 0;
      flex-shrink: 0;

      //grid layout
      grid-column-end: span 1;
      &.open {
        grid-column-end: span 2;
        grid-row-end: span 2;
      }


      padding: 20px 20px 10px;
      border: none;
      article {
        text-align: center;
      }
      h2 {
        @include font-size(20px);
        font-weight: 400;
      }
      figure {
        text-align: center;
        height: 147px;
        margin: 0 17% 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      nav {
        display: flex;
        align-items: flex-start;
        > .link {
          flex-grow: 1;
          flex-shrink: 1;
        }
        > button {
          flex-basis: 145px;
          flex-grow: 0;
        }
      }
      p {
        margin: 25px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/general/Apps.vue